/* eslint-disable no-unused-vars */
/* eslint-disable no-const-assign */
import React, { useState, useEffect, useRef } from "react";
import "./../../../assets/css/purchase/form.css";
import moment from "moment";
import Breadcrumbs from "../../components/Breadcrumbs";
import Sidebar from "../../components/Sidebar";
import {
  formatCurrency,
  getAlert,
  getData,
  getDataWithComp,
  getDataWithJoin,
  parseCurrency,
} from "../../../utils/SamuiUtils";
import { exportHtmlTableToExcel } from "../../../utils/ExportUtils";
import { getReport } from "../../../utils/ReportUtils";
import Pagination from "../../components/Footer/Pagination";
import { convertDateNoTime, formatDateCheque } from "../../../utils/DateUtils";
import DatePicker from "../../components/DatePicker";

const MoneyTransferReport = () => {
  const [name, setName] = useState(null);

  const [filteredData1, setFilteredData1] = useState([]);
  const [currentPage1, setCurrentPage1] = useState(1);
  const [itemsPerPage1, setItemsPerPage1] = useState(10);
  const [itemsPerPageDropdown1, setItemsPerPageDropdown1] = useState(10);

  const [filteredData2, setFilteredData2] = useState([]);
  const [currentPage2, setCurrentPage2] = useState(1);
  const [itemsPerPage2, setItemsPerPage2] = useState(10);
  const [itemsPerPageDropdown2, setItemsPerPageDropdown2] = useState(10);

  const [searchDocDate, setSearchDocDate] = useState(moment());
  const [searchDlId, setSearchDlId] = useState("");
  const [searchPkRound, setSearchPkRound] = useState("");
  const [dlLineList, setDlLineList] = useState([]);

  const [selectedRow1, setSelectedRow1] = useState(null);
  const [selectedRow2, setSelectedRow2] = useState(null);
  const [isExportingReport1, setIsExportingReport1] = useState(false);
  const [isExportingReport2, setIsExportingReport2] = useState(false);
  const tableRef1 = useRef(null);
  const tableRef2 = useRef(null);

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    setName("9. รายงานการส่งเงิน");
    setFilteredData1([]);
    setFilteredData2([]);
    const dlDataList = await getDataWithComp("DL_Line_H", "ORDER By DL_Id ASC");
    if (dlDataList && dlDataList.length > 0) {
      setDlLineList(dlDataList);
    }
    handleSearch();
  };

  const getGroupedDataWithSummary = (data) => {
    const grouped = {};

    data.forEach((item) => {
      const lineName = item.DL_LineName || "ไม่ระบุสายรถ";
      if (!grouped[lineName]) {
        grouped[lineName] = {
          items: [],
          summary: {
            DL_LineName: lineName,
            pk_round: "รวม",
            B1000_value: 0,
            B500_value: 0,
            B100_value: 0,
            B50_value: 0,
            B20_value: 0,
            B10_value: 0,
            B5_value: 0,
            B2_value: 0,
            B1_value: 0,
            sum_amt: 0,
            isSummary: true,
          },
        };
      }

      grouped[lineName].items.push(item);

      grouped[lineName].summary.B1000_value +=
        parseCurrency(item.B1000_value) || 0;
      grouped[lineName].summary.B500_value +=
        parseCurrency(item.B500_value) || 0;
      grouped[lineName].summary.B100_value +=
        parseCurrency(item.B100_value) || 0;
      grouped[lineName].summary.B50_value += parseCurrency(item.B50_value) || 0;
      grouped[lineName].summary.B20_value += parseCurrency(item.B20_value) || 0;
      grouped[lineName].summary.B10_value += parseCurrency(item.B10_value) || 0;
      grouped[lineName].summary.B5_value += parseCurrency(item.B5_value) || 0;
      grouped[lineName].summary.B2_value += parseCurrency(item.B2_value) || 0;
      grouped[lineName].summary.B1_value += parseCurrency(item.B1_value) || 0;
      grouped[lineName].summary.sum_amt += parseCurrency(item.sum_amt) || 0;
    });

    const result = [];
    Object.keys(grouped).forEach((lineName) => {
      result.push(...grouped[lineName].items);
      result.push(grouped[lineName].summary);
    });

    return result;
  };

  const getGroupedData2WithSummary = (data) => {
    const grouped = {};

    data.forEach((item) => {
      const lineName = item.DL_LineName || "ไม่ระบุสายรถ";
      if (!grouped[lineName]) {
        grouped[lineName] = {
          items: [],
          summary: {
            Doc_No: "",
            AR_Name: "",
            DL_LineName: lineName,
            Paid_Status: "รวม",
            Paid_Type: "",
            Paid_Amt: 0,
            Pay_Cheque_No: "",
            Bank_Name: "",
            Paid_Date: "",
            Remark: "",
            isSummary: true,
          },
        };
      }

      grouped[lineName].items.push(item);

      grouped[lineName].summary.Paid_Amt += parseCurrency(item.Paid_Amt) || 0;
    });

    const result = [];
    Object.keys(grouped).forEach((lineName) => {
      result.push(...grouped[lineName].items);
      result.push(grouped[lineName].summary);
    });

    return result;
  };
  const handleSearch = async () => {
    try {
      if (searchDocDate === "" || searchDocDate === null) {
        return;
      }

      setFilteredData1([]);
      setFilteredData2([]);

      let where1 = `pkh.Doc_Date = '${convertDateNoTime(
        searchDocDate
      )}' AND pkh.Doc_Status <> '1' AND pkh.Doc_Status <> '13' AND (COALESCE(pkc.B1000, 0) * 1000 + COALESCE(pkc.B500, 0) * 500 + COALESCE(pkc.B100, 0) * 100 + COALESCE(pkc.B50, 0) * 50 + COALESCE(pkc.B20, 0) * 20 + COALESCE(pkc.B10, 0) * 10 + COALESCE(pkc.B5, 0) * 5 + COALESCE(pkc.B2, 0) * 2 + COALESCE(pkc.B1, 0) * 1) > 0.00`;
      if (searchDlId) where1 += ` AND pkh.Delivery_Line_Id = ${searchDlId}`;
      if (searchPkRound) where1 += ` AND pkh.PK_Round = ${searchPkRound}`;

      const response1 = await getDataWithJoin(
        `
              pkh.Doc_No,
              pkh.Doc_Date,
              dlh.DL_LineName,
              pkh.Doc_Status,
              CASE 
                  when pkh.PK_Round = 1 then 'เช้า' 
                  when pkh.PK_Round = 2 then 'เย็น' 
                  when pkh.PK_Round = 3 then 'ค่ำ' 
              END AS pk_round,
              pkc.B1000 * 1000 AS B1000_value,
              pkc.B500 * 500 AS B500_value,
              pkc.B100 * 100 AS B100_value,
              pkc.B50 * 50 AS B50_value,
              pkc.B20 * 20 AS B20_value,
              pkc.B10 * 10 AS B10_value,
              pkc.B5 * 5 AS B5_value,
              pkc.B2 * 2 AS B2_value,
              pkc.B1 * 1 AS B1_value,
              COALESCE(pkc.B1000, 0) * 1000 + 
              COALESCE(pkc.B500, 0) * 500 + 
              COALESCE(pkc.B100, 0) * 100 + 
              COALESCE(pkc.B50, 0) * 50 + 
              COALESCE(pkc.B20, 0) * 20 + 
              COALESCE(pkc.B10, 0) * 10 + 
              COALESCE(pkc.B5, 0) * 5 + 
              COALESCE(pkc.B2, 0) * 2 + 
              COALESCE(pkc.B1, 0) * 1 AS sum_amt
              `,
        `PKList_H as pkh`,
        `
              LEFT JOIN PKList_CloseMoney as pkc ON (pkh.Doc_Id = pkc.PKList_Id)
              LEFT JOIN DL_Line_H as dlh ON (pkh.Delivery_Line_Id = dlh.DL_Id)
              WHERE ${where1}
              ORDER BY dlh.DL_LineName, pkh.PK_Round, pkh.Doc_No
              `,
        ""
      );

      let where2 = `pkh.Doc_Date = '${convertDateNoTime(searchDocDate)}'`;
      if (searchDlId) where2 += ` AND pkh.Delivery_Line_Id = ${searchDlId}`;
      if (searchPkRound) where2 += ` AND pkh.PK_Round = ${searchPkRound}`;

      const response2 = await getDataWithJoin(
        `
              soh.Doc_No,
              ar.AR_Name,
              dlh.DL_LineName,
              CASE 
                  when soh.Doc_Status_Paid = 1 then 'รอจ่าย' 
                  when soh.Doc_Status_Paid = 2 then 'ค้างจ่าย' 
                  when soh.Doc_Status_Paid = 3 then 'ชำระแล้ว' 
              END AS Paid_Status,
              CASE 
                  when soh.Doc_Status_Paid_Type = 1 then 'เงินสด' 
                  when soh.Doc_Status_Paid_Type = 2 then 'โอน' 
                  when soh.Doc_Status_Paid_Type = 3 then 'เช็ค' 
                  when soh.Doc_Status_Paid_Type = 4 then 'เครดิต' 
                  when soh.Doc_Status_Paid_Type = 5 then 'ค้างจ่าย' 
                  when soh.Doc_Status_Paid_Type = 6 AND phs.Pay_Type = 1 then 'เงินสด' 
                  when soh.Doc_Status_Paid_Type = 6 AND phs.Pay_Type = 2 then 'โอน' 
                  when soh.Doc_Status_Paid_Type = 6 AND phs.Pay_Type = 3 then 'เช็ค' 
              END AS Paid_Type,
              CASE 
                  when soh.Doc_Status_Paid_Type = 1 then soh.NetTotal 
                  when soh.Doc_Status_Paid_Type = 2 then soh.NetTotal 
                  when soh.Doc_Status_Paid_Type = 3 then soh.NetTotal 
                  when soh.Doc_Status_Paid_Type = 4 then soh.NetTotal 
                  when soh.Doc_Status_Paid_Type = 5 then soh.NetTotal 
                  when soh.Doc_Status_Paid_Type = 6 AND phs.Pay_Type = 1 then phs.Pay_Amount 
                  when soh.Doc_Status_Paid_Type = 6 AND phs.Pay_Type = 2 then phs.Pay_Amount 
                  when soh.Doc_Status_Paid_Type = 6 AND phs.Pay_Type = 3 then phs.Pay_Amount 
              END AS Paid_Amt,
              phs.Pay_Cheque_No,
              CASE 
                  when phs.Bank_Id IS NOT NULL then bnk.Bank_Name_TH 
                  when phs.Bank_Master_Id IS NOT NULL then bmt.B_Name_TH 
              END AS Bank_Name,
              CASE 
                  when phs.Pay_Cheque_No IS NOT NULL then phs.Pay_Cheque_date 
                  ELSE phs.Pay_Datetime 
              END AS Paid_Date,
              '' AS Remark
              `,
        `API_0701_SO_H as soh`,
        `
              LEFT JOIN PKList_H pkh ON (soh.Ref_DocID = pkh.Doc_Id)
              LEFT JOIN Pay_History phs ON (phs.Doc_Id = soh.Doc_Id)
              LEFT JOIN Tb_Set_AR ar ON (ar.AR_Id = soh.AR_ID)
              LEFT JOIN DL_Line_H as dlh ON (pkh.Delivery_Line_Id = dlh.DL_Id)
              LEFT JOIN Tb_Set_Bank bnk ON (bnk.Bank_Id = phs.Bank_Id)
              LEFT JOIN Tb_Set_Bank_Master bmt ON (bmt.Bank_Master_Id = phs.Bank_Master_Id)
              WHERE ${where2}
              ORDER BY dlh.DL_LineName, soh.Doc_No
              `,
        ""
      );

      if (response1 && response1.length > 0) {
        setFilteredData1(response1);
      } else {
        setFilteredData1([]);
      }

      if (response2 && response2.length > 0) {
        setFilteredData2(response2);
      } else {
        setFilteredData2([]);
      }

      if (
        (!response1 || response1.length === 0) &&
        (!response2 || response2.length === 0)
      ) {
      }
    } catch {}
  };

  const handleChangeSearchDocDate = (value) => {
    const formattedDate =
      value && value instanceof moment ? value.format("YYYY-MM-DD") : "";
    setSearchDocDate(formattedDate);
  };

  const handleChangeSearchDlId = (e) => {
    setSearchDlId(e.target.value);
  };

  const handleChangeSearchPkRound = (e) => {
    setSearchPkRound(e.target.value);
  };

  const handlePageChange1 = (pageNumber) => {
    setCurrentPage1(pageNumber);
  };

  const handleItemsPerPageChange1 = (event) => {
    const newItemsPerPage = parseCurrency(event.target.value);
    setItemsPerPageDropdown1(newItemsPerPage);
    setItemsPerPage1(newItemsPerPage);
    handlePageChange1(1);
  };

  const handlePageChange2 = (pageNumber) => {
    setCurrentPage2(pageNumber);
  };

  const handleItemsPerPageChange2 = (event) => {
    const newItemsPerPage = parseCurrency(event.target.value);
    setItemsPerPageDropdown2(newItemsPerPage);
    setItemsPerPage2(newItemsPerPage);
    handlePageChange2(1);
  };

  const handleExportReport1 = async () => {
    if (!groupedData1 || groupedData1.length === 0) {
      getAlert("FAILED", "ไม่มีข้อมูลสำหรับ Export");
      return;
    }

    if (!tableRef1.current) {
      getAlert("FAILED", "ไม่พบตารางข้อมูลสำหรับ Export");
      return;
    }

    try {
      setIsExportingReport1(true);
      const dateStamp = moment(searchDocDate).isValid()
        ? moment(searchDocDate).format("YYYYMMDD")
        : moment().format("YYYYMMDD");
      const fileName = `money-transfer-cash_${dateStamp}_${moment().format(
        "HHmmss"
      )}.xlsx`;
      await exportHtmlTableToExcel(tableRef1.current, {
        sheetName: `${name || "รายงานการส่งเงิน"} - ส่งเงิน`,
        fileName,
        headerLines: [
          "รายงานการส่งเงิน",
          `รายการส่งเงินสมุยไอซ์ - วันที่ ${formatDateCheque(searchDocDate)}`,
        ],
      });
    } catch (error) {
      console.error("Export money transfer report (cash) error:", error);
      getAlert("FAILED", "ไม่สามารถ Export ข้อมูลได้");
    } finally {
      setIsExportingReport1(false);
    }
  };

  const handleExportReport2 = async () => {
    if (!groupedData2 || groupedData2.length === 0) {
      getAlert("FAILED", "ไม่มีข้อมูลสำหรับ Export");
      return;
    }

    if (!tableRef2.current) {
      getAlert("FAILED", "ไม่พบตารางข้อมูลสำหรับ Export");
      return;
    }

    try {
      setIsExportingReport2(true);
      const dateStamp = moment(searchDocDate).isValid()
        ? moment(searchDocDate).format("YYYYMMDD")
        : moment().format("YYYYMMDD");
      const fileName = `money-transfer-payment_${dateStamp}_${moment().format(
        "HHmmss"
      )}.xlsx`;
      await exportHtmlTableToExcel(tableRef2.current, {
        sheetName: `${name || "รายงานการส่งเงิน"} - รายการชำระ`,
        fileName,
        headerLines: [
          "รายงานการส่งเงิน",
          `รายการส่งเช็ค - วันที่ ${formatDateCheque(searchDocDate)}`,
        ],
      });
    } catch (error) {
      console.error("Export money transfer report (payment) error:", error);
      getAlert("FAILED", "ไม่สามารถ Export ข้อมูลได้");
    } finally {
      setIsExportingReport2(false);
    }
  };

  const groupedData1 = getGroupedDataWithSummary(filteredData1);
  const groupedData2 = getGroupedData2WithSummary(filteredData2);

  const indexOfLastItem1 = currentPage1 * itemsPerPage1;
  const indexOfFirstItem1 = indexOfLastItem1 - itemsPerPage1;
  const currentItems1 = groupedData1.slice(indexOfFirstItem1, indexOfLastItem1);

  const indexOfLastItem2 = currentPage2 * itemsPerPage2;
  const indexOfFirstItem2 = indexOfLastItem2 - itemsPerPage2;
  const currentItems2 = groupedData2.slice(indexOfFirstItem2, indexOfLastItem2);

  const startIndex1 = (currentPage1 - 1) * itemsPerPageDropdown1 + 1;
  const endIndex1 = Math.min(
    currentPage1 * itemsPerPageDropdown1,
    groupedData1.length
  );

  const startIndex2 = (currentPage2 - 1) * itemsPerPageDropdown2 + 1;
  const endIndex2 = Math.min(
    currentPage2 * itemsPerPageDropdown2,
    groupedData2.length
  );

  return (
    <>
      <Sidebar />
      <div className="main-panel">
        <div className="container">
          <div className="page-inner">
            <div className="page-header d-flex justify-content-between align-items-center">
              <Breadcrumbs
                page={name}
                items={[
                  { name: "รายงาน", url: "/reports" },
                  { name: name, url: "/money-transfer-report" },
                ]}
              />
            </div>

            {/* Filter Controls */}
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header">
                    <h4>เงื่อนไขการค้นหา</h4>
                  </div>
                  <div className="card-body">
                    <div className="col-md-2">
                      <DatePicker
                        label="วันที่เอกสาร"
                        name="searchDocDate"
                        value={searchDocDate}
                        onChange={(date) => handleChangeSearchDocDate(date)}
                        disabled={false}
                      />
                    </div>
                    <div className="col-md-12 d-flex justify-content-end">
                      <button
                        type="button"
                        className="btn btn-lg shadow text-white"
                        style={{
                          width: "10%",
                          marginRight: "20px",
                          backgroundColor: "#EF6C00",
                          fontSize: "16px",
                        }}
                        onClick={handleSearch}
                      >
                        <i className="fas fa-search" /> ค้นหา
                      </button>
                      <button
                        type="button"
                        className="btn btn-lg shadow text-white"
                        style={{
                          width: "10%",
                          backgroundColor: "#EF6C00",
                          fontSize: "16px",
                        }}
                        onClick={() => initialize()}
                      >
                        <i className="fas fa-undo" /> เริ่มใหม่
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {/* Report 1: รายงานนำส่งเงิน */}
              <div className="col-md-12 mt-4">
                <div className="card">
                  <div className="card-header d-flex justify-content-between align-items-start flex-wrap">
                    <h4>
                      รายการส่งเงินสมุยไอซ์ - วันที่{" "}
                      {formatDateCheque(searchDocDate)}
                    </h4>
                    <button
                      type="button"
                      className="btn btn-lg shadow text-white"
                      style={{ backgroundColor: "#EF6C00", fontSize: "16px", minWidth: "150px" }}
                      onClick={handleExportReport1}
                      disabled={
                        isExportingReport1 || !groupedData1 || groupedData1.length === 0
                      }
                    >
                      <i className="fas fa-file-excel" />{" "}
                      {isExportingReport1 ? "กำลังส่งออก..." : "Export"}
                    </button>
                  </div>
                  <div className="card-body">
                    <div
                      className="table-responsive"
                      style={{ maxHeight: "550px", overflowY: "auto" }}
                    >
                      <table
                        className="table table-striped table-hover"
                        ref={tableRef1}
                      >
                        <thead className="thead-dark">
                          <tr>
                            <th className="text-center">สายรถ</th>
                            <th className="text-center">รอบ</th>
                            <th className="text-center">1000</th>
                            <th className="text-center">500</th>
                            <th className="text-center">100</th>
                            <th className="text-center">50</th>
                            <th className="text-center">20</th>
                            <th className="text-center">10</th>
                            <th className="text-center">5</th>
                            <th className="text-center">2</th>
                            <th className="text-center">1</th>
                            <th className="text-center">รวม</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentItems1.length > 0 ? (
                            currentItems1.map((data, index, array) => {
                              const rowId = data.Doc_No || `row-${index}`;
                              const isSummary = data.isSummary;

                              const isFirstInGroup =
                                !isSummary &&
                                (index === 0 ||
                                  (array[index - 1] &&
                                    array[index - 1].DL_LineName !==
                                      data.DL_LineName));

                              return (
                                <tr
                                  key={rowId}
                                  className={isSummary ? "summary-row" : ""}
                                  style={{
                                    cursor: isSummary ? "default" : "pointer",
                                    backgroundColor: isSummary
                                      ? "#ADD8E6"
                                      : "transparent",
                                    transition: "background-color 0.3s ease",
                                    fontWeight: isSummary ? "bold" : "normal",
                                  }}
                                  onClick={() =>
                                    !isSummary && setSelectedRow1(rowId)
                                  }
                                >
                                  <td className="text-center">
                                    {isFirstInGroup
                                      ? data.DL_LineName || "-"
                                      : ""}
                                  </td>
                                  <td className="text-center">
                                    {data.pk_round || "-"}
                                  </td>
                                  <td className="text-end">
                                    {isSummary
                                      ? formatCurrency(data.B1000_value || 0)
                                      : data.B1000_value && data.B1000_value > 0
                                      ? formatCurrency(data.B1000_value)
                                      : ""}
                                  </td>
                                  <td className="text-end">
                                    {isSummary
                                      ? formatCurrency(data.B500_value || 0)
                                      : data.B500_value && data.B500_value > 0
                                      ? formatCurrency(data.B500_value)
                                      : ""}
                                  </td>
                                  <td className="text-end">
                                    {isSummary
                                      ? formatCurrency(data.B100_value || 0)
                                      : data.B100_value && data.B100_value > 0
                                      ? formatCurrency(data.B100_value)
                                      : ""}
                                  </td>
                                  <td className="text-end">
                                    {isSummary
                                      ? formatCurrency(data.B50_value || 0)
                                      : data.B50_value && data.B50_value > 0
                                      ? formatCurrency(data.B50_value)
                                      : ""}
                                  </td>
                                  <td className="text-end">
                                    {isSummary
                                      ? formatCurrency(data.B20_value || 0)
                                      : data.B20_value && data.B20_value > 0
                                      ? formatCurrency(data.B20_value)
                                      : ""}
                                  </td>
                                  <td className="text-end">
                                    {isSummary
                                      ? formatCurrency(data.B10_value || 0)
                                      : data.B10_value && data.B10_value > 0
                                      ? formatCurrency(data.B10_value)
                                      : ""}
                                  </td>
                                  <td className="text-end">
                                    {isSummary
                                      ? formatCurrency(data.B5_value || 0)
                                      : data.B5_value && data.B5_value > 0
                                      ? formatCurrency(data.B5_value)
                                      : ""}
                                  </td>
                                  <td className="text-end">
                                    {isSummary
                                      ? formatCurrency(data.B2_value || 0)
                                      : data.B2_value && data.B2_value > 0
                                      ? formatCurrency(data.B2_value)
                                      : ""}
                                  </td>
                                  <td className="text-end">
                                    {isSummary
                                      ? formatCurrency(data.B1_value || 0)
                                      : data.B1_value && data.B1_value > 0
                                      ? formatCurrency(data.B1_value)
                                      : ""}
                                  </td>
                                  <td className="text-end">
                                    {formatCurrency(data.sum_amt || 0)}
                                  </td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td colSpan={12}>
                                <center>
                                  <h5>ไม่พบข้อมูล</h5>
                                </center>
                              </td>
                            </tr>
                          )}
                        </tbody>
                        <tfoot className="table-primary">
                          <tr>
                            <td colSpan={2} className="text-end">
                              <b>รวมทั้งหมด</b>
                            </td>
                            {[
                              "B1000_value",
                              "B500_value",
                              "B100_value",
                              "B50_value",
                              "B20_value",
                              "B10_value",
                              "B5_value",
                              "B2_value",
                              "B1_value",
                            ].map((field) => (
                              <td className="text-end" key={field}>
                                <b>
                                  {formatCurrency(
                                    filteredData1.reduce((sum, data) => {
                                      const value =
                                        parseCurrency(data[field]) || 0;
                                      return sum + value;
                                    }, 0)
                                  )}
                                </b>
                              </td>
                            ))}
                            <td className="text-end">
                              <b>
                                {formatCurrency(
                                  filteredData1.reduce((sum, data) => {
                                    const value = parseCurrency(data.sum_amt);
                                    return sum + (isNaN(value) ? 0 : value);
                                  }, 0)
                                )}
                              </b>
                            </td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>

                    {/* Pagination for Report 1 */}
                    <div className="d-flex justify-content-between align-items-center p-3">
                      <div>
                        <select
                          value={itemsPerPageDropdown1}
                          onChange={handleItemsPerPageChange1}
                          className="form-select"
                        >
                          <option value={10}>10</option>
                          <option value={20}>20</option>
                          <option value={30}>30</option>
                          <option value={50}>50</option>
                          <option value={100}>100</option>
                        </select>
                      </div>
                      <div>
                        <span>
                          แสดง {startIndex1}-{endIndex1} ของ{" "}
                          {groupedData1.length.toLocaleString()} รายการ
                        </span>
                      </div>
                      <Pagination
                        currentPage={currentPage1}
                        setCurrentPage={setCurrentPage1}
                        itemsPerPage={itemsPerPageDropdown1}
                        dataMasterList={groupedData1}
                        handlePageChange={handlePageChange1}
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Report 2: รายงานประวัติการชำระเงิน */}
              <div className="col-md-12 mt-4">
                <div className="card">
                  <div className="card-header d-flex justify-content-between align-items-start flex-wrap">
                    <h4>
                      รายการส่งเช็ค - วันที่ {formatDateCheque(searchDocDate)}
                    </h4>
                    <button
                      type="button"
                      className="btn btn-lg shadow text-white"
                      style={{ backgroundColor: "#EF6C00", fontSize: "16px", minWidth: "150px" }}
                      onClick={handleExportReport2}
                      disabled={
                        isExportingReport2 || !groupedData2 || groupedData2.length === 0
                      }
                    >
                      <i className="fas fa-file-excel" />{" "}
                      {isExportingReport2 ? "กำลังส่งออก..." : "Export"}
                    </button>
                  </div>
                  <div className="card-body">
                    <div
                      className="table-responsive"
                      style={{ maxHeight: "500px", overflowY: "auto" }}
                    >
                      <table
                        className="table table-striped table-hover"
                        ref={tableRef2}
                      >
                        <thead className="thead-dark">
                          <tr>
                            <th className="text-center">เลขที่ใบขาย</th>
                            <th className="text-center">ชื่อลูกค้า</th>
                            <th className="text-center">สายรถ</th>
                            <th className="text-center">สถานะชำระเงิน</th>
                            <th className="text-center">ช่องทางชำระ</th>
                            <th className="text-center">จำนวนเงิน</th>
                            <th className="text-center">เลขที่</th>
                            <th className="text-center">ธนาคาร</th>
                            <th className="text-center">วันสั่งจ่าย</th>
                            <th className="text-center">หมายเหตุ</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentItems2.length > 0 ? (
                            currentItems2.map((data, index, array) => {
                              const rowId = data.Doc_No || `row2-${index}`;
                              const isSummary = data.isSummary;

                              const isFirstInGroup =
                                !isSummary &&
                                (index === 0 ||
                                  (array[index - 1] &&
                                    array[index - 1].DL_LineName !==
                                      data.DL_LineName));

                              return (
                                <tr
                                  key={rowId}
                                  className={isSummary ? "summary-row" : ""}
                                  style={{
                                    cursor: isSummary ? "default" : "pointer",
                                    backgroundColor: isSummary
                                      ? "#ADD8E6"
                                      : "transparent",
                                    transition: "background-color 0.3s ease",
                                    fontWeight: isSummary ? "bold" : "normal",
                                  }}
                                  onClick={() =>
                                    !isSummary && setSelectedRow2(rowId)
                                  }
                                >
                                  <td className="text-center">
                                    {data.Doc_No || "-"}
                                  </td>
                                  <td className="text-left">
                                    {data.AR_Name || "-"}
                                  </td>
                                  <td className="text-center">
                                    {isFirstInGroup
                                      ? data.DL_LineName || "-"
                                      : ""}
                                  </td>
                                  <td className="text-center">
                                    {data.Paid_Status ? (
                                      isSummary ? (
                                        <span className="badge bg-info">
                                          {data.Paid_Status}
                                        </span>
                                      ) : (
                                        <span
                                          className={`badge ${
                                            data.Paid_Status === "ชำระแล้ว"
                                              ? "bg-success"
                                              : data.Paid_Status === "รอจ่าย"
                                              ? "bg-warning"
                                              : "bg-danger"
                                          }`}
                                        >
                                          {data.Paid_Status}
                                        </span>
                                      )
                                    ) : (
                                      "-"
                                    )}
                                  </td>
                                  <td className="text-center">
                                    {data.Paid_Type ? (
                                      <span
                                        className={`badge ${
                                          data.Paid_Type === "เงินสด"
                                            ? "bg-success"
                                            : data.Paid_Type === "โอน"
                                            ? "bg-info"
                                            : data.Paid_Type === "เช็ค"
                                            ? "bg-primary"
                                            : data.Paid_Type === "เครดิต"
                                            ? "bg-warning"
                                            : "bg-secondary"
                                        }`}
                                      >
                                        {data.Paid_Type}
                                      </span>
                                    ) : (
                                      "-"
                                    )}
                                  </td>
                                  <td className="text-end">
                                    {formatCurrency(data.Paid_Amt || 0)}
                                  </td>
                                  <td className="text-center">
                                    {data.Pay_Cheque_No || "-"}
                                  </td>
                                  <td className="text-center">
                                    {data.Bank_Name || "-"}
                                  </td>
                                  <td className="text-center">
                                    {data.Paid_Date
                                      ? moment(data.Paid_Date).format(
                                          "DD-MM-YYYY"
                                        )
                                      : "-"}
                                  </td>
                                  <td className="text-center">
                                    {data.Remark || "-"}
                                  </td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td colSpan={10}>
                                <center>
                                  <h5>ไม่พบข้อมูล</h5>
                                </center>
                              </td>
                            </tr>
                          )}
                        </tbody>
                        <tfoot className="table-primary">
                          <tr>
                            <td colSpan={5} className="text-end">
                              <b>รวมทั้งหมด</b>
                            </td>
                            <td className="text-end">
                              <b>
                                {formatCurrency(
                                  filteredData2.reduce((sum, data) => {
                                    const value = parseCurrency(data.Paid_Amt);
                                    return sum + (isNaN(value) ? 0 : value);
                                  }, 0)
                                )}
                              </b>
                            </td>
                            <td colSpan={4}></td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>

                    {/* Pagination for Report 2 */}
                    <div className="d-flex justify-content-between align-items-center p-3">
                      <div>
                        <select
                          value={itemsPerPageDropdown2}
                          onChange={handleItemsPerPageChange2}
                          className="form-select"
                        >
                          <option value={10}>10</option>
                          <option value={20}>20</option>
                          <option value={30}>30</option>
                          <option value={50}>50</option>
                          <option value={100}>100</option>
                        </select>
                      </div>
                      <div>
                        <span>
                          แสดง {startIndex2}-{endIndex2} ของ{" "}
                          {groupedData2.length.toLocaleString()} รายการ
                        </span>
                      </div>
                      <Pagination
                        currentPage={currentPage2}
                        setCurrentPage={setCurrentPage2}
                        itemsPerPage={itemsPerPageDropdown2}
                        dataMasterList={groupedData2}
                        handlePageChange={handlePageChange2}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MoneyTransferReport;
